import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import React, { ReactNode } from "react";
import { GREY } from "@/config/mui/colorPalette";
import { CopyIcon } from "../icons";

type CopyTextProps = {
  content?: string | ReactNode;
  textToCopy: string;
  onCopySuccess?: () => void;
  onCopyError?: () => void;
};

export default function CopyText({
  content,
  textToCopy,
  onCopySuccess,
  onCopyError,
}: CopyTextProps) {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      onCopySuccess?.();
    } catch (error) {
      console.error("Failed to copy text:", error);
      onCopyError?.();
    }
  };

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Typography
        variant="body2"
        sx={{
          flex: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {content || textToCopy}
      </Typography>
      <Tooltip title="Copy">
        <IconButton size="small" onClick={handleCopy} sx={{ ml: "auto" }}>
          <CopyIcon color={GREY[60]} />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
